import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type OptInFormV2 } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: OptInFormV2.Api.InitRequest
  ): Promise<HttpApiResponse<OptInFormV2.Api.InitResponse>> => api.get(apiInfo, `/api/site/v1/modules/optInForm`, args),
  submit: (
    apiInfo: ModuleApiInfo,
    args: OptInFormV2.Api.SubmitRequest
  ): Promise<HttpApiResponse<OptInFormV2.Api.SubmitResponse>> =>
    api.post<OptInFormV2.Api.SubmitResponse>(apiInfo, `/api/site/v1/modules/optInForm`, {
      ...args,
      ...apiInfo.baseParams
    }),
  sendOtp: (
    apiInfo: ModuleApiInfo,
    args: OptInFormV2.Api.SendOtpRequest
  ): Promise<HttpApiResponse<OptInFormV2.Api.SendOtpResponse>> =>
    api.post<OptInFormV2.Api.SendOtpResponse>(apiInfo, `/api/site/v1/modules/optInForm/otp/send`, args)
};
